export const ApiResources = {
  // Auth
  ACCESS_TOKEN: 'auth/token',
  REFRESH_TOKEN: 'auth/refresh-token',
  RECUPERAR_SENHA: 'auth/recuperar-senha',
  ALTERAR_SENHA: 'auth/alterar-senha',
  LOGOUT: 'auth/logout',
  MULTI_CLIENT_ACESS: 'auth/client-change',
  // Usuarios
  USERS: 'usuarios',
  // Usuarios Vinculados
  USERS_VINCULADOS: 'usuarios/clientes-vinculados',
  // Anexos
  ANEXOS: 'anexos',
  // Atendimentos
  ATENDIMENTOS: 'atendimentos',
  // Faturamento
  FATURAMENTO: 'faturamento',
  // Multas
  MULTAS: 'multas',
  MULTAS_CONDUTOR: 'multas/condutor',
  MULTAS_CONDUTOR_CONTRATO: 'multas/condutor-contrato',
  MOTIVOS_ATENDIMENTO: 'atendimentos/motivos',
  MOTIVOS_SINISTRO: 'atendimentos/sinistros/motivos',
  // Condutores
  CONDUTORES: 'condutores',
  // Municipios
  MUNICIPIOS: 'municipios',
  // Veículos
  VEICULOS: 'veiculos',
  INSPECOES: 'veiculos/inspecoes',
  // Contratos
  CONTRATOS: 'contratos',
  CONTRATO_STATUS: 'contratos/status',
  FROTA_CONTRATADA: 'contratos/frota-contratada',
  CONDUTOR_CONTRATO: 'contratos/condutor',
  // Grupo de contratos]
  CONTRATOS_GRUPOS: 'contratos-grupos',
  CONTRATOS_GRUPOS_LISTAGEM_FATURAMENTO: 'contratos-grupos/listagem-faturamento',
  // Ordens de serviço
  ORDEM_SERVICO: 'ordem-servico',
  // Pneus
  PNEU: 'ordem-servico/pneus',
  // Notificações
  NOTIFICACAO: 'notificacoes',
  // Outros
  THEME: 'temas',
  /**
   *API Locavia Web
   */
  //Medicoes (LW)
  MEDICOES: 'medicoes',
  CATEGORIA: 'condutores/categoria-cnh',
  //Fornecedores
  FORNECEDORES: 'fornecedores',
  //Indicadores
  INDICADORES: 'indicadores',
  TIPOENDERECO: 'tipo-endereco',
  PAISES: 'paises',
  PORTALCLIENTE: 'portal-cliente',
};
